<template>
    <ReviewsIndicator v-if="isRatingVisible" :appraisals="appraisals!" />
    <template v-else-if="sectionVisibility[SectionsVisibilityType.RECOMMENDATIONS] && (hasRecommendations || isEditionEnabled)">
        <RecommendationsIndicator v-if="hasRecommendations" :recommendations-count="recommendations!.recommendationsCount" />
        <slot v-else-if="isEditionEnabled" name="ask-for-recommendations" />
    </template>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useProfilePageViewMode} from '~/composables/useProfilePageViewMode';
    import {useSectionsVisibilityStore} from '~/store/sectionsVisibility';
    import type {Appraisals} from '~/types/domain/Appraisals';
    import type {Recommendations} from '~/types/domain/Recommendations';
    import {SectionsVisibilityType} from '~/types/domain/SectionsVisibility';
    import RecommendationsIndicator from './RecommendationsIndicator.vue';
    import ReviewsIndicator from './ReviewsIndicator.vue';

    const props = defineProps<{
        appraisals?: Appraisals;
        recommendations?: Recommendations;
    }>();

    const isRatingVisible = computed((): boolean => (props.appraisals?.ratings.general && props.appraisals?.ratings.general > 2) || false);
    const hasRecommendations = computed((): boolean => (props.recommendations?.recommendationsCount ?? 0) > 0);

    const {isEditionEnabled} = useProfilePageViewMode();
    const {sectionVisibility} = storeToRefs(useSectionsVisibilityStore());
</script>

<style scoped lang="scss">
    .reviews-recommendations-indicator__link {
        font-weight: var(--joy-font-weight-normal);
        white-space: nowrap;
    }
</style>
